import functions from '../../functions';

if (window.wp && window.wp.ajax) {
    const { registerBlockType } = window.wp.blocks;
    const { InspectorControls, InnerBlocks, BlockControls, AlignmentToolbar } = window.wp.editor;
    const { PanelBody, TextareaControl, ToggleControl, SelectControl } = window.wp.components;
    const { createElement } = window.wp.element;

    // Helper: render multi-line text with <br>
    function renderHeadingWithBreaks(text, tag, className) {
        if (!text) return null;
        const lines = text.split('\n');
        const children = [];

        lines.forEach((line, index) => {
            children.push(line);
            if (index < lines.length - 1) {
                children.push(createElement('br'));
            }
        });

        return createElement(tag, { className }, children);
    }

    function bs5Align(align) {
        if (align === 'left') return 'text-start';
        if (align === 'right') return 'text-end';
        return 'text-center';
    }

    registerBlockType('custom-gutenberg/arrangement-hero', {
        title: 'Arrangement Hero',
        description: 'Subtitle, Title & Description with alignment and heading tag control.',
        icon: 'airplane',
        category: 'custom-cards',
        example: {},

        attributes: {
            subtitle: { type: 'string', default: 'ARANŽMANI' },
            title: { type: 'string', default: 'Za vas samo najbolje' },
            description: { type: 'string', default: '' },
            anchor: { type: 'string', default: '' },
            classes: { type: 'string', default: '' },
            textAlign: { type: 'string', default: 'center' },
            headingLevel: { type: 'number', default: 2 } // <--- NEW
        },

        edit: function (props) {
            const { attributes, setAttributes } = props;
            const { subtitle, title, description, anchor, classes, textAlign, headingLevel } = attributes;

            let className = props.className;
            className = functions.getClassNames(className);
            if (classes !== className) setAttributes({ classes: className });

            const HeadingTag = "h" + headingLevel;

            return [
                /* -------------------------------
                   Inspector Controls (Sidebar)
                -------------------------------- */
                createElement(
                    InspectorControls,
                    { style: { marginBottom: '40px' } },

                    createElement(
                        PanelBody,
                        { title: 'Hero Block Settings' },

                        createElement(TextareaControl, {
                            label: 'Subtitle',
                            value: subtitle,
                            onChange: (val) => setAttributes({ subtitle: val })
                        }),

                        createElement(TextareaControl, {
                            label: 'Title',
                            value: title,
                            onChange: (val) => setAttributes({ title: val })
                        }),

                        createElement(TextareaControl, {
                            label: 'Description',
                            value: description,
                            onChange: (val) => setAttributes({ description: val })
                        }),

                        /* Heading Tag Selector */
                        createElement(SelectControl, {
                            label: 'Heading Level',
                            value: headingLevel,
                            options: [
                                { label: 'H1', value: 1 },
                                { label: 'H2', value: 2 },
                                { label: 'H3', value: 3 },
                                { label: 'H4', value: 4 },
                                { label: 'H5', value: 5 },
                                { label: 'H6', value: 6 }
                            ],
                            onChange: (val) => setAttributes({ headingLevel: parseInt(val) })
                        })
                    )
                ),

                /* -------------------------------
                   Block Controls (Toolbar)
                -------------------------------- */
                createElement(
                    BlockControls,
                    {},
                    createElement(AlignmentToolbar, {
                        value: textAlign,
                        onChange: (newAlign) => setAttributes({ textAlign: newAlign })
                    })
                ),

                /* -------------------------------
                   Editor View
                -------------------------------- */

                
                createElement(
                    'div',
                    {
                        id: anchor,
                        className: `${classes} ${bs5Align(textAlign)} p-4`
                    },

                    subtitle
                        ? renderHeadingWithBreaks(subtitle, 'div', 'text-uppercase small text-warning mb-2')
                        : null,

                    title
                        ? renderHeadingWithBreaks(title, HeadingTag, 'fw-bold position-relative d-inline-block mb-3 hero-title')
                        : null,

                    description
                        ? renderHeadingWithBreaks(description, 'p', 'text-muted mx-auto')
                        : null,

                    createElement(InnerBlocks)
                )
            ];
        },

        save: function (props) {
            const { subtitle, title, description, anchor, classes, textAlign, headingLevel } = props.attributes;

            const HeadingTag = "h" + headingLevel;

            // Convert multiline text to <br>
            function convert(text) {
                if (!text) return null;
                const parts = text.split('\n');
                const children = [];

                parts.forEach((line, idx) => {
                    children.push(line);
                    if (idx < parts.length - 1) {
                        children.push(createElement('br'));
                    }
                });

                return children;
            }

            return createElement(
                'div',
                { id: anchor, className: `${classes} ${bs5Align(textAlign)}` },

                subtitle
                    ? createElement('div', { className: 'text-uppercase small text-warning mb-2 subheading' }, convert(subtitle))
                    : null,

                title
                    ? createElement(HeadingTag, { className: 'fw-bold position-relative d-inline-block mb-3 hero-title' }, 
                        createElement('div', { className: 'position-relative'}, convert(title))
                    )
                    : null,

                description
                    ? createElement('p', { className: 'description' }, convert(description))
                    : null,

                createElement(InnerBlocks.Content)
            );
        }
    });
}
